import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";
 

export const getAllAddress = createAsyncThunk(
  "/address/get",
  async (_, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/address/all");
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e:any) {
      return rejectWithValue(e.data.message);
    }
  }
);

export const getAllCities = createAsyncThunk(
  "/address/cities",
  async (_, { rejectWithValue }) =>{
    try {
      const{data, errorMessage, isSuccess} = await commonNetwork.get("/address/cities");
      if (isSuccess) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error: any) {
      return rejectWithValue(error.data.message);
    }
  }
);

export const getAllDistricts = createAsyncThunk(
  "/address/alldistricts",
  async(_, { rejectWithValue }) => {
    try {
      const{data, errorMessage, isSuccess} = await commonNetwork.get(`/address/alldistricts`);
      if (isSuccess) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error: any) {
      return rejectWithValue(error.data.message);
    }
  }
)

export const getDistrictByCity = createAsyncThunk(
  "/address/districts",
  async(cityId: any, { rejectWithValue }) => {
    try {
      const{data, errorMessage, isSuccess} = await commonNetwork.get(`/address/districts/${cityId}`);
      if (isSuccess) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (error: any) {
      return rejectWithValue(error.data.message);
    }
  }
)
 
export type UserInfoType={
userName: string,
userCode: string,
userEmail: string,
userPhone:string,
userDesc:boolean
}

export interface userStateType  extends FetchResultType{
    userInformations:UserInfoType
}
export const addressSlice = createSlice({
  name: "address",
  initialState: {
    userInformations: {},
    isfirmAvailable: true,
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.userInformations = {};
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAddress.fulfilled, (state, { payload }) => {
      state.userInformations = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false; 
      return state;
    });
    builder.addCase(getAllAddress.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true; 
      // state.errorMessage = payload.message;
    });
    builder.addCase(getAllAddress.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = addressSlice.actions;

export const addressSelector = (state:any) => state.address;

export const addressReducer = addressSlice.reducer;
